import {FC, PropsWithChildren,  Row, Col, Form} from 'external/react'

type ConfigurationRowProps = {
    label: string
    isLast?: boolean
}

const ConfigurationRow:FC<PropsWithChildren<ConfigurationRowProps>> = props => {
    const {label, children, isLast = false} = props
    return (<>
     <Row className='mt-5 mb-5'>
            <Col sm={1} />
            <Col sm={3}>
                <Form.Label className='fw-bold'>
                    {label}
                </Form.Label>
            </Col>
            <Col sm={6}>
               {children}
            </Col>
            <Col sm={2} />
        </Row>
       {!isLast && <hr className='text-muted' />}
      </>
    )
}

export {ConfigurationRow as default}